/* Shared visible quantity control, with a hidden bridge for the quote app. */
(() => {
  if (window.hsProductQuantityController) return;

  const bindings = new Map();
  const pending = new Set();
  let scheduled = false;

  function initialise(info) {
    const row = info.querySelector('.product-form__buttons-row');
    const quantity = row?.querySelector('.product-form__quantity');
    const price = info.querySelector('.price-wrapper[id^="price-"]');

    // Position the price/quantity controls ahead of the accessory choices.
    // Keep the original purchase form and its Add to Cart button in place.
    const productButtons = row?.closest('[data-id^="ProductButtons-"]');
    const apoBlock = Array.from(info.children).find(el =>
      el.matches('.shopify-app-block') &&
      el.id.includes('apo_product_options_app_block')
    );
    if (row && productButtons && apoBlock &&
        (apoBlock.compareDocumentPosition(productButtons) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      // Quantity stays associated with its original Shopify product form.
      const form = row.closest('form[id]');
      const quantityInput = quantity?.querySelector('input[name="quantity"]');
      if (form && quantityInput) {
  quantityInput.setAttribute('form', form.getAttribute('id'));
}
      info.insertBefore(row, apoBlock);
      // Keep the real Add to Cart button below the Mageworx options.
      // Moving the button alone retains its existing product-form association.
      const cartButton = row.querySelector('.product-form__submit');
      if (cartButton && cartButton.parentElement === row) {
        cartButton.setAttribute(
  'form',
  form?.getAttribute('id') || cartButton.getAttribute('form') || ''
);
        productButtons.appendChild(cartButton);
      }
    }

    // Use Mageworx's own cart handler when Advanced Pricing is active.
    // The original Mageworx button stays in the DOM, visually hidden.
    const visibleCart = productButtons?.querySelector('.product-form__submit');
    if (visibleCart && !visibleCart.dataset.hsMageworxBridge) {
      visibleCart.dataset.hsMageworxBridge = 'true';
      visibleCart.addEventListener('click', event => {
        const mageworxCart = info.querySelector(
          '.shopify-app-block[id*="apo_product_options_app_block"] button.mw-apo-add-to-cart-custom'
        );
        if (!mageworxCart || mageworxCart.disabled) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        mageworxCart.click();
      }, true);
    }

    if (row && quantity) {
      info.classList.add('product-controls-single-quantity');
      row.classList.add('product-controls-purchase-grid');

      if (price && price.parentElement !== row) {
        row.insertBefore(price, quantity);
      }
    }

    info.querySelectorAll('.mprfq-add-to-quote-button-pdp')
      .forEach(button => {
        const source = row?.querySelector(
          '.product-form__quantity quantity-input'
        );
        const input = source?.querySelector('.quantity__input');
        if (!input) return;

        const previous = bindings.get(button);
        if (
          previous?.input === input &&
          previous.clone.isConnected
        ) return;

        if (previous) {
          previous.controller.abort();
          previous.clone.remove();
        }

        let wrapper = button.closest('.mprfq-quote-with-qty');

        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'mprfq-quote-with-qty';
          button.parentNode.insertBefore(wrapper, button);
          wrapper.append(button);
        }

        const clone = source.cloneNode(true);
        clone.classList.add(
          'mprfq-qty-clone',
          'mprfq-quantity-bridge'
        );
        clone.setAttribute('aria-hidden', 'true');

        const cloneInput = clone.querySelector('.quantity__input');
        cloneInput.removeAttribute('id');
        cloneInput.removeAttribute('name');
        cloneInput.removeAttribute('form');
        cloneInput.setAttribute('aria-label', 'Quantity for quote');

        clone.querySelectorAll('input,button').forEach(el => {
          el.setAttribute('tabindex', '-1');
        });

        wrapper.insertBefore(clone, button);

        const controller = new AbortController();

        function sync() {
          cloneInput.value = input.value;

          ['min', 'max', 'step'].forEach(name => {
            if (input.hasAttribute(name)) {
              cloneInput.setAttribute(
                name,
                input.getAttribute(name)
              );
            } else {
              cloneInput.removeAttribute(name);
            }
          });
        }

        ['input', 'change'].forEach(type => {
          input.addEventListener(type, sync, {
            signal: controller.signal
          });
        });

        button.addEventListener('click', sync, {
          capture: true,
          signal: controller.signal
        });

        sync();
        bindings.set(button, {input, clone, controller});
      });
  }

  function flush() {
    scheduled = false;

    bindings.forEach((binding, button) => {
      if (!button.isConnected || !binding.input.isConnected) {
        binding.controller.abort();
        binding.clone.remove();
        bindings.delete(button);
      }
    });

    const panels = Array.from(pending);
    pending.clear();

    panels.forEach(info => {
      if (info.isConnected) initialise(info);
    });
  }

  function schedule() {
    if (scheduled || !pending.size) return;

    scheduled = true;
    requestAnimationFrame(flush);
  }

  function collect(root) {
    if (root.nodeType === 1) {
      const info = root.closest('.product__info-container');
      if (info) pending.add(info);
    }

    root.querySelectorAll?.('.product__info-container')
      .forEach(info => pending.add(info));

    schedule();
  }

  function start() {
    collect(document);

    // Process product-panel changes, ignoring unrelated page changes.
    new MutationObserver(records => {
      records.forEach(record => {
        const info = record.target.nodeType === 1
          ? record.target.closest('.product__info-container')
          : null;

        if (info) pending.add(info);

        record.addedNodes.forEach(node => {
          if (node.nodeType === 1) collect(node);
        });
      });

      schedule();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  window.hsProductQuantityController = true;

  document.addEventListener('shopify:section:load', event => {
    collect(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();